/**
 * Insurance-related models
 */

/**
 * Insurance DTO (Response)
 */
export interface InsuranceDto {
  id: string;
  vesselId: string;
  carrierName: string;
  policyNumber: string;
  expiryDate: string;
  certificateUrl?: string | null;
  additionalInsuredVerified: boolean;
  verifiedBy?: string | null;
  verifiedAt?: string | null;
  /** Marina business name at verification time. */
  verifiedByMarinaName?: string | null;
  createdAt: string;
  updatedAt: string;
}

